import ApiBase from './base/ApiBase'
import { Position } from '../models/dtos';

class PositionClient extends ApiBase {
    private controllerName: string = 'Position';

    async Create(ctx: PositionUpsertContext, signal?: AbortSignal): Promise<string> {
        return this.PostAsync(`${this.controllerName}`, ctx, signal);
    }

    async Delete(id: string, signal?: AbortSignal): Promise<void> {
        return this.DeleteAsync(`${this.controllerName}/${id}`, signal);
    }

    async GetAll(signal?: AbortSignal): Promise<Position[]> {
        return this.GetAsync(`${this.controllerName}`, signal);
    }

    async GetSingle(id: string, signal?: AbortSignal): Promise<Position> {
        return this.GetAsync(`${this.controllerName}/${id}`, signal);
    }

    async Update(id: string, ctx: PositionUpsertContext, signal?: AbortSignal): Promise<void> {
        return this.PutAsync(`${this.controllerName}/${id}`, ctx, signal);
    }

}

export interface PositionUpsertContext {
    Title: string;
    Description: string;
}

export enum PositionErrors {
    Create = 'Error creating Position',
    Delete = 'Error deleting Position',
    GetAll = 'Error loading Position',
    GetSingle = 'Error loading Position',
    Update = 'Error saving Position',

}

export default PositionClient;
